import { generateUid, validateProject, getSection } from '../utils/index';

import { CALCULATION_TYPE_PLANE, CALCULATION_CLONE, CALCULATION_REMOVE, createCalculation, changeType } from '../modules/calculation';

import { PROJECT_ADD, PROJECT_REMOVE, addProject, updateProjectToProjects } from '../modules/projects';


import { selectProject, closeCreateNewProjectDialog, INITIAL_STATE, PROJECT_SELECT, PROJECT_PATCH, PROJECT_SAVE, VALIDATE_PROJECT } from '../modules/project';

import { projectSaveToServer, projectPatchToServer } from '../modules/user';

import { patchArchiveItem } from '../modules/archive';

import { getUIText, getCalculation } from '../utils/index';


export function createMiddleware() {
  return store => next => action => {
    const { type, payload } = action;
    const { project, translations, app, projects, user } = store.getState();

    switch (type) {

      case PROJECT_SAVE:
        if(project.hasOwnProperty('uuid')) {
          store.dispatch(projectPatchToServer(payload));
        } else {
          store.dispatch(projectSaveToServer(payload));
        }

        break;

      case PROJECT_PATCH:
        if(payload && payload.hasOwnProperty('useMarineProducts')) {
          store.dispatch(patchArchiveItem( getCalculation(store.getState().project)) );
          if(payload && payload.hasOwnProperty('unsaved')) {
            next(action);
          } else {
            next({
              ...action,
              payload: {
                ...payload,
                unsaved: true
              }
            });
          }
          store.dispatch(changeType( { type: getCalculation(store.getState().project).type, skipPatchArchiveItem: true } ));
        } else {
          if(payload && payload.hasOwnProperty('unsaved')) {
            next(action);
          } else {
            next({
              ...action,
              payload: {
                ...payload,
                unsaved: true
              }
            });
          }
        }
        break;

      case PROJECT_ADD:

        const newProject = {
          ...payload.project,
          id: generateUid(),
        };

        next({
          ...action,
          payload: newProject
        });

        store.dispatch(selectProject({id: newProject.id}));
        store.dispatch(createCalculation({
          name: getUIText('CALCULATION-DEFAULT_NAME', app.language, translations) + ' 1', // 'Calc 1',  //ui['CALCULATION-DEFAULT_NAME']
          id: generateUid(),
          sectionIndex: 0,
          type: CALCULATION_TYPE_PLANE,
        }));

        if(payload.saveToDB) {
          store.dispatch(projectSaveToServer({success: closeCreateNewProjectDialog}));
        }

        break;

      case CALCULATION_REMOVE:
        next(action);

        const { project: newP } = store.getState();
        if(newP && newP.calculations && !newP.calculations.length) {
          const c = getCalculation(project);
          const s = getSection(c);
          let type = s && s.type ? s.type : CALCULATION_TYPE_PLANE;

          store.dispatch(createCalculation({
            name: getUIText('CALCULATION-DEFAULT_NAME', app.language, translations) + ' 1', // 'Calc 1',
            id: generateUid(),
            sectionIndex: 0,
            type: type,
          }));
        }
        break;

      case CALCULATION_CLONE:
        next(action);

        const {
          calculations,
          calculationIndex
        } = project;

        const calculation = calculations ? calculations[calculationIndex] : {};

        if(calculation) {
          let cloneNum = 1;
          let cloneName = calculation.name + ' (' + cloneNum + ')';

          if(calculation.hasOwnProperty('cloneNum')) {
            cloneNum = (parseInt(calculation.cloneNum) + 1);
            cloneName = calculation.name.replace(/ *\([^)]*\) */g, '') + ' (' + cloneNum + ')';
          }

          const o = {
            ...calculation,
            name: cloneName,
            cloneNum: cloneNum,
            cloned: true
          };

          store.dispatch(createCalculation(o));
        }
        break;

      case PROJECT_SELECT:
        if(projects && payload.id) {
          let p = projects.find( (item) => {
            if(item.id === payload.id) {
              return true;
            }
          });

          // TODO: Bug. comes here twice(2x) when you change project (PROJECT_SELECT)
          p = validateProject(p, store.getState());

          // update current project in projects
          if(user.username && !payload.doNotSaveToProjects) {
            store.dispatch(updateProjectToProjects(project));
          }

          if(p) {
            next({
              ...action,
              payload: p
            });
          }
        }
        break;

      case VALIDATE_PROJECT:
        const p = validateProject(project, store.getState());
        if(p) {
          next({
            ...action,
            payload: p
          });
        }
        break;

      case PROJECT_REMOVE:
        next(action);
        if(projects && payload && payload.id) {
          let projectIndex = projects.findIndex((item) => {
            if(item.id === payload.id) {
              return true;
            }
          });

          let tempProjects = projects.filter( (item) => {
            if(item.id != payload.id) {
              return true;
            }
          });

          let newProjectIndex;
          if(projectIndex != undefined && tempProjects.length) {
            if(tempProjects[projectIndex]) {
              newProjectIndex = projectIndex;
            } else if(tempProjects[tempProjects.length - 1]) {
              newProjectIndex = tempProjects.length - 1;
            } else {
              newProjectIndex === 0;
            }

            // TODO: if no projects generate default project

            if(tempProjects[newProjectIndex]) {
              store.dispatch(selectProject({id: tempProjects[newProjectIndex].id}));
            }
          } else {
            if(!tempProjects.length) {
              store.dispatch(
                addProject({
                  project:
                    {
                      ...INITIAL_STATE,
                      title: getUIText('PROJECTS-DEFAULT_PROJECT_NAME', app.language, translations)
                    }
                  }
                )
              );
            }
          }
        }
        break;


        default:
        next(action);
    }
  };
}
